import {
  setTooltip,
  setStateTooltip
} from "./redux/actions/index";

/* Public Methods Available For LRoot */
function Root(Base, store) {
  class NewRoot extends Base {

    tooltips_toggle(state) {
      store.dispatch(setStateTooltip(state));
    }
    tooltip(title = null, description = null) {
      const val = (!title && !description) ? null : { title, description };
      store.dispatch(setTooltip(val));
    }

  }
  return NewRoot;
}

export default Root;
